<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fjXdQl/tc-custom/9781459206625.jpg?1743865819604" alt="This image is the cover for the book His Sheltering Arms"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Sheltering Arms
      </h1>
      <p class="bookDescription body article font2">
        <p>His job was to keep Erin Brailey safe. But first, security expert Zach Miller had to convince the sultry beauty that she needed his protection...while keeping his desire for her hidden lest it lure them both into danger....<br/><br/>Taking control of her life for the first time, Erin wanted to rely on herself—even though Zach looked more than capable of handling all her needs. But after exchanging heated embraces with her new protector, Erin couldn’t help wondering: Was the safest place she could be...right in Zach’s arms?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristi Gold
      </h2>
      
      <p class="authorDescription body article">Since her first venture into novel writing in the mid-nineties, Kristi Gold has greatly enjoyed weaving stories of love and commitment. She's an avid fan of baseball, beaches and bridal reality shows.&#160; During her career, Kristi has been a National Readers Choice winner, Romantic Times award winner, and a three-time Romance Writers of America RITA finalist.&#160; She resides in Central Texas and can be reached through her website&#160;at http://kristigold.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60203210